var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6464 4.64645C17.8417 4.45118 18.1583 4.45118 18.3536 4.64645L23.3536 9.64645C23.5488 9.84171 23.5488 10.1583 23.3536 10.3536L10.3536 23.3536C10.2598 23.4473 10.1326 23.5 10 23.5H5C4.72386 23.5 4.5 23.2761 4.5 23V18C4.5 17.8674 4.55268 17.7402 4.64645 17.6464L17.6464 4.64645ZM5.5 18.2071V22.5H9.79289L22.2929 10L18 5.70711L5.5 18.2071Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.176cb7eb.svg";
export { ForwardRef as ReactComponent };